import React from 'react'
import { Helmet } from 'react-helmet'

import FieldNameSimulator from '@components/children/simulator/FieldNameSimulator'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
// actions
import * as USER_ACTION from '@store/user/actions'
import * as PRODUCTS_ACTION from '@store/products/actions'
import * as SHARED_ACTION from '@store/shared/actions'

import { Icon } from '@components/shared/elements'

import TOOLS from '@helpers/tools'

import MaskedInput from 'react-text-mask'

import './Simulador.scss'

class SimuladorHome extends React.Component {
  constructor(props) {
    super(props)

    this.isSimulatorActived = false

    this.state = {
      loading: false,
      success: true,
      name: '',
      phone: '',
      phoneDirt: false,
      apiReturnSuccess: '',
      apiReturnError: '',
      idImovel: 'Sem produto',
      dadosImovel: null,
    }

    this.props.actions.updateShowNewsletter(false)
  }

  componentWillMount() {
    const searchParams = new URLSearchParams(window.location.search)
    const ob = Object.fromEntries(searchParams.entries())

    let imovel = {
      idImovel: parseInt(ob.idimovel, 10),
    }

    if (imovel.idImovel) {
      this.props.actions.getProductById(imovel.idImovel).then(result => this.setState({
        dadosImovel: result.imovel,
      }))
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    localStorage.setItem('simulator-datalayer', '')

    this.props.actions.updateSimulatorActived(window.location.href)
  }


  //Evento ao enviar o formulario simulador
  _handleSubmit(event) {
    event.preventDefault()

    this.setState({ loading: true })

    const submitReturnError = document.querySelector('.submitReturnError')
    const urlCampanha = localStorage.getItem('campaign-params')
    const produto = this.state.dadosImovel ? `${this.state.dadosImovel.GuidCrm}` : 'Sem produto'


    const raw = JSON.stringify({
      'nome': `${this.state.name}`,
      'numero': `${this.state.phone}`,
      'urlCampanha': urlCampanha,
      'produto': produto,

    })


    this.props.actions.submitSimuladorForm(raw)
      .then(response => {
        // submitReturnSuccess.classList.remove('hidden')
        this.setState({
          loading: false,
        })

        // guardamos para fazer o push do datalayer na tela de sucesso
        let BIItem = {
          'event': 'setResult',
          'infoUsuario': {
            'nome': `${this.state.name}`,
            'numero': `${this.state.phone}`,
          },
          'urlCampanha': urlCampanha,
          'produto': produto,
        }

        if (response !== 'success') {
          submitReturnError.classList.remove('hidden')
        }

        localStorage.setItem('simulator-datalayer', JSON.stringify({ BIItem }))

        this.props.history.push({
          pathname: '/simulador/sucesso',
        })
      })
      .catch(error => {
        this.setState({
          loading: false,
          success: false,
        })
        submitReturnError.classList.remove('hidden')
      })
  }

  render() {
    let phoneValid
    let nameValid

    if (this.state.phoneDirt || this.state.phone !== '') {
      phoneValid = TOOLS.phoneValid(this.state.phone) ? 'is-valid' : 'has-error'
    }

    if (this.state.name !== '') {
      nameValid = TOOLS.fullNameValid(this.state.name) ? 'is-valid' : 'has-error'
    }

    let formValid = (
      phoneValid === 'is-valid' &&
      nameValid === 'is-valid'
    )

    return (
      <div className='simulador'>
        <Helmet>
          <title>Simulador de Imóveis | Vivaz</title>
          <meta name='description' content='Você está só a alguns passar de realizar o sonho da casa própria. Acesse o simulador CVA e com apenas algumas perguntas saiba qual será o seu subsídio e taxas.' />

          <script type='application/ld+json'>
            {`{
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                'itemListElement': [
                  {
                    '@type': 'ListItem',
                    'position': 1,
                    'item': 'https://www.meuvivaz.com.br/',
                    'name': 'Página Inicial'
                  },
                  {
                    '@type': 'ListItem',
                    'position': 2,
                    'item': 'https://www.meuvivaz.com.br${this.props.location.pathname}',
                    'name': 'Simulador'
                  }
                ]
              }`}
          </script>
        </Helmet>

        <section className='wow clearfix large'>
          <div className='grid-container mt8 mb8'>
            <div className='grid-x'>
              <div className='cell medium-6 large-5'>
                <div className='mb3'>
                  <strong style={{ color: '#363338' }}>Simulador</strong>
                </div>
                <h1 className='h4 break-space mb4'>
                  <strong>Faltam poucos passos para realizar seu sonho da casa própria!</strong>
                </h1>
              </div>
              <div className='cell medium-6 large-offset-1'>
                <form
                  onSubmit={(event) => this._handleSubmit(event)}
                  data-ga-name='section-simulador-passo-01'
                  id={this.state.shBranchId}
                >
                  <div className='mb4'>
                    <strong style={{ color: '#363338' }}>Qual o seu nome completo?</strong>
                    <FieldNameSimulator
                      showInvalid={this.state.formValid}
                      onUpdateValue={(result) => this.setState({ name: result })}
                    />
                  </div>
                  <div className='mb3'>
                    <strong style={{ color: '#363338' }}>Qual o seu Whatsapp?</strong>
                    <div className='mt2 text-small text-bold text--secondary'>Atenção! Lembre-se de colocar um número de whatsapp válido para poder fazer a simulação.</div>
                    <div className={`field-group mb2 ${phoneValid === 'is-valid' && 'is-valid'} ${phoneValid === 'has-error' && 'has-error'}`}>
                      <label>
                        <MaskedInput
                          mask={TOOLS.cellphoneMask(this.state.phone)}
                          guide={false}
                          className='mb0'
                          type='tel'
                          value={this.state.phone}
                          onChange={(event) => this.setState({ phone: event.target.value })}
                          onBlur={() => this.setState({ phoneDirt: true })}
                          placeholder='(00) 0000-0000'
                        />
                        <div className='text-small text-error ml1 mt1'>Informe um número de celular válido</div>
                      </label>
                      <span className='icon mr1'>
                        <span className='field-icon'>
                          <Icon icon='phone' size='sm' />
                        </span>
                        <span className='text-error'>
                          <Icon icon='times' size='sm' />
                        </span>
                        <span className='text-success'>
                          <Icon icon='check' size='sm' />
                        </span>
                      </span>
                    </div>
                  </div>
                  <div>
                    <label htmlFor='agree-terms-field'>
                      A Vivaz preza pela sua privacidade, e os dados pessoais que coletamos vão atender o que determina a legislação aplicável. Para saber mais, acesse nossa{' '}
                      <a href='/termos-privacidade' title='Política de Privacidade' target='_blank' rel='noreferrer noopener'>Política de Privacidade</a>
                    </label>
                  </div>
                  <footer className='mt4 mb4'>
                    <button className='button mb0 min-width' type='submit' disabled={this.state.loading || !formValid}>{this.state.loading ? 'Enviando...' : 'Enviar'}</button>
                  </footer>
                  <p className='submitReturnSuccess hidden h6'>
                    Obrigado pelo seu cadastro! Vamos continuar com sua simulação no WhatsApp para facilitar nossa comunicação, combinado? Já te chamaremos por lá. Até!
                  </p>
                  <p className='submitReturnError hidden h6'>
                    Tivemos um problema no envio da sua solicitação. Por favor, tente novamente!
                  </p>
                </form>
              </div>
            </div>
          </div>
        </section>

      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    currentUser: state.user.currentUser,
    simulatorActived: state.shared.simulatorActived,
    simulatorResult: state.shared.simulatorResult,
    cities: state.shared.cities,
    region: state.shared.region,
    lastProductCity: state.shared.lastProductCity,
    shBranchId: state.shared.shBranchId,
    locations: state.locations.estados,
    branches: state.shared.regionBranches,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...SHARED_ACTION,
      ...PRODUCTS_ACTION,
      ...USER_ACTION,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SimuladorHome)



// WEBPACK FOOTER //
// ./src/components/children/Simulador/SimuladorHome.js